module.exports = __webpack_public_path__ + "static/media/sausage.64a53848.svg";